import { apiClient } from './client';

export interface ProbationRecord {
  id: number; employee_id: number; employee_name?: string; staff_id?: string; supervisor_name?: string;
  start_date: string; expected_end_date: string; supervisor_id: number | null;
  status: 'in_progress' | 'under_review' | 'confirmed' | 'extended' | 'non_confirmed';
  supervisor_recommendation: string | null; supervisor_recommendation_comments: string | null;
  hr_decision: string | null; hr_decision_comments: string | null; extension_new_end_date: string | null;
}

export interface ProbationObjective { id: number; objective: string }
export interface ProbationReview { id: number; review_date: string; assessment: string; strengths: string | null; areas_for_improvement: string | null; submitted_by_name: string }

export const probationApi = {
  listAll: () => apiClient.get<{ data: ProbationRecord[] }>('/api/probation-records'),
  alerts: () => apiClient.get<{ data: { expiringSoon: ProbationRecord[]; overdue: ProbationRecord[] } }>('/api/probation-records/alerts'),
  mine: () => apiClient.get<{ data: ProbationRecord[] }>('/api/probation/mine'),
  pendingForMyRecommendation: () => apiClient.get<{ data: ProbationRecord[] }>('/api/probation/pending-my-recommendation'),
  getById: (id: number) => apiClient.get<{ data: ProbationRecord; objectives: ProbationObjective[]; reviews: ProbationReview[] }>(`/api/probation-records/${id}`),
  getForEmployee: (employeeId: number) => apiClient.get<{ data: ProbationRecord[] }>(`/api/employees/${employeeId}/probation`),
  create: (input: { employeeId: number; startDate: string; expectedEndDate: string; objectives?: string[] }) =>
    apiClient.post<{ data: { id: number } }>('/api/probation-records', input),
  addReview: (id: number, input: { reviewDate: string; assessment: string; strengths?: string; areasForImprovement?: string }) =>
    apiClient.post<{ data: { id: number } }>(`/api/probation-records/${id}/reviews`, input),
  submitSupervisorRecommendation: (id: number, input: { recommendation: 'confirm' | 'extend' | 'non_confirm'; comments: string }) =>
    apiClient.post<{ data: { status: string } }>(`/api/probation-records/${id}/supervisor-recommendation`, input),
  recordHrDecision: (id: number, input: { decision: 'confirmed' | 'extended' | 'non_confirmed'; comments: string; extensionNewEndDate?: string }) =>
    apiClient.post<{ data: { status: string } }>(`/api/probation-records/${id}/hr-decision`, input),
};
